import { StyleSheet } from 'react-native';
import Theme from 'Theme';
import { Device } from 'DeviceUtils';

const defaultStyles = {
    container: {
        flex: 1,
        padding: 15,
        alignSelf: 'stretch',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#000000',
        paddingHorizontal: Theme.primaryMargim,
        width: '100%'
    },
    onCloseStyle: {
        backgroundColor: 'rgba(0,0,0,0.8)',
        flexDirection: 'row'
    },
    innerContainer: {
        flex: 1,
        alignSelf: 'stretch',
        justifyContent: 'center',
        alignItems: 'center',
        paddingHorizontal: 50
    },
    titleContainer: {
        flexDirection: 'column',
        alignSelf: 'stretch',
        justifyContent: 'center',
        alignItems: 'center'
    },
    titleContainerLandscape: {
        flexDirection: 'row'
    },
    infoIcon: {
        width: 20,
        height: 20,
        marginBottom: 10
    },
    title: {
        fontFamily: Theme.regularFont,
        fontSize: 25,
        marginHorizontal: 18,
        marginBottom: 10,
        color: Theme.primaryTextColor
    },
    message: {
        marginTop: 25,
        color: Theme.secondaryTextColor,
        fontSize: 16,
        textAlign: 'center',
        marginBottom: 15
    },
    iconContainerLandscape: {
        right: 10,
        top: Device.isIos ? 0 : 15,
        position: 'absolute'
    },
    closableContainer: { backgroundColor: 'rgba(0,0,0,0.9)' }
};

export default StyleSheet.create(defaultStyles);
